import Api from '@/services/Api' // axois object created in api.js
import { ProgramInfo, Assessment, ProgramPackageForPurchase } from '../types'

export default { // export its register method
  // getProgram ({ tutorId = null, organizationId = null, statusCodes = null }) {
  //   return Api().get('program/', { params: { tutorId: tutorId, organizationId: organizationId, statusCodes: statusCodes } })
  // },
  getClasses ({ programIds, statusCodes = [0, 1, 2, 3] }: { programIds: number[]; statusCodes: number[]}) {
    return Api().get('program/classes', { params: { programIds: programIds, statusCodes: statusCodes } })
  },
  getHostMoneyRecordsById ({ hostId, limit, offset }: {hostId: number; limit?: number; offset?: number}) {
    console.log(`getHostMoneyRecordsById, hostId: ${hostId}. /nSending request via GET method to server, waiting for response ...`)
    return Api().get('finance/host-transaction-records/', { params: { hostId: hostId, limit: limit, offset: offset } })
  },
  getPrograms ({ tutorId, organizationId, statusCodes }: { tutorId?: number; organizationId?: number; statusCodes?: number[] }) {
    return Api().get('program', { params: { tutorId, organizationId, statusCodes } })
  },
  getCategorizedPrograms ({ tutorId, organizationId, organizationGroupIds, programIds, isPublished, isDraft, isPending, isSnapshot, isClosed }: {tutorId: number; organizationId: number; organizationGroupIds: number[]; programIds: number[]; isPublished: boolean; isDraft: boolean; isPending: boolean; isSnapshot: boolean; isClosed: boolean}) {
    return Api().get('program/get-programs', { params: { tutorId, organizationId, organizationGroupIds, programIds, isPublished, isDraft, isPending, isSnapshot, isClosed } })
  },
  getProgramsFromCommonProperty ({ programCommonPropertyIds, programCommonPropertyStatusCodes, tutorIds, organizationIds, programIds, organizationGroupIds, first }: {programCommonPropertyIds: number[]; programCommonPropertyStatusCodes: number[]; tutorIds: number[]; organizationIds: number[]; programIds: number[]; organizationGroupIds: number[]; first: boolean}) {
    return Api().get('program/get-programs-from-common-property', { params: { programCommonPropertyIds, programCommonPropertyStatusCodes, tutorIds, organizationIds, programIds, organizationGroupIds, first } })
  },
  getStudents ({ programIds, organizationIds, studentIds, enrollmentStatusCodes, classIds, offset, limit }: { programIds?: number[]; organizationIds?: number[]; studentIds?: number[]; enrollmentStatusCodes?: number[]; classIds?: number[]; offset?: number; limit?: number }) {
    console.log('ProgramService.getStudents starts ... ')
    return Api().get('program/students/', { params: { programIds, organizationIds, studentIds, enrollmentStatusCodes, classIds, offset, limit } })
  },
  getOrganizationTransactionRecordsByOrganizationId (organizationId: number, limit: number, offset: number) {
    console.log('Sending request via GET method to server, waiting for response ...')
    return Api().get('finance/org-transaction-records', { params: { organizationId: organizationId, limit: limit, offset: offset } })
  },
  studentClassDisenrollment (studentId: number, classId: number) {
    console.log('\n studentClassDisenrollment: Sending request via POST method to server, waiting for response ...')
    return Api().delete('program/class-enrollment', { params: { studentId: studentId, classId: classId } })
  },
  studentClassEnroll (studentIds: number, classId: number) {
    console.log('#\nstudentClassEnroll: sending request via POST method to server, waiting for response ...')
    return Api().post('program/class-enrollment', { studentIds: studentIds, classId: classId })
  },
  getClassStatusItems () {
    return Api().get('program/class-status-items')
  },
  updateClassStatus (classId: number, statusCode: number) {
    console.log(`updateClassStatus: classId: ${classId}, statusCode: ${statusCode}`)
    return Api().put('program/class-update', { id: classId, statusCode: statusCode })
  },
  getStudentLessonRecords (studentId: number, programId: number, limit: number, offset: number) {
    console.log('Sending request via GET method to server, waiting for response ...')
    return Api().get('finance/student-lesson-records', { params: { studentId: studentId, programId: programId, limit: limit, offset: offset } })
  },
  // upsertClass (classInfo) {
  //   console.log('ProgramService.upsertClass starts ... ')
  //   return Api().put('program/class-upsert', classInfo)
  // },
  deleteClass (classId: number) {
    return Api().delete('program/class-delete', { params: { classId: classId } })
  },
  getTutors ({ tutorId, mobile, organizationId }: {tutorId?: number; mobile?: string; organizationId?: number}) {
    console.log('Sending request via GET method to server, waiting for server response ...')
    return Api().get('program/tutors', { params: { tutorId: tutorId, mobile, organizationId: organizationId } })
  },
  getProgramCategory3 () {
    console.log('Sending request via GET method to server, waiting for server response ...')
    return Api().get('program-category-3', { params: { codes: null } })
  },
  getProgramCategory2 (category3Codes: number) {
    console.log('Sending request via GET method to server, waiting for server response ...')
    return Api().get('program-category-2', { params: { category3Codes: category3Codes } })
  },
  getProgramCategory (category2Codes: number) {
    console.log('Sending request via GET method to server, waiting for server response ...')
    return Api().get('program-category', { params: { category2Codes: category2Codes } })
  },
  getProgramPrerequisiteTags () {
    console.log('Sending request via GET method to server, waiting for server response ...')
    return Api().get('program/prerequisite-tags', { params: {} })
  },
  getProgramTags () {
    console.log('Sending request via GET method to server, waiting for server response ...')
    return Api().get('program/program-tags', { params: {} })
  },
  getProgramTargetStudentTags () {
    console.log('Sending request via GET method to server, waiting for server response ...')
    return Api().get('program/target-student-tags', { params: {} })
  },
  getProgramObjectiveTags () {
    console.log('Sending request via GET method to server, waiting for server response ...')
    return Api().get('program/objective-tags', { params: {} })
  },
  upsertProgram (programInfo: ProgramInfo) {
    console.log(`Sending request to server ... programInfo: ${programInfo}`)
    return Api().post('program/program-upsert', { programInfo })
  },
  deletePrograms ({ programCommonPropertyIds }: {programCommonPropertyIds: number[]}) {
    console.log(' ProgramService.deletePrograms...')
    return Api().delete('program/delete-programs', { params: { programCommonPropertyIds } })
  },
  approvalRequest ({ programCommonPropertyId, programId }: {programCommonPropertyId: number; programId: number}) {
    console.log('ProgramService.approvalRequest... ')
    return Api().post('program/program-approval-request', { programCommonPropertyId, programId })
  },
  approvalRequestWithdraw ({ programApprovalRequestId }: {programApprovalRequestId: number}) {
    console.log('ProgramService.approvalRequest... ')
    return Api().post('program/program-approval-request-withdraw', { programApprovalRequestId })
  },
  approvalRequestsAssessments ({ assessments }: {assessments: Assessment[]}) {
    console.log('ProgramService.approvalRequestsAssessments... ')
    return Api().post('program/program-approval-requests-assessments', { assessments })
  },
  attachThumbnail ({ programCommonPropertyId, fileName }: { programCommonPropertyId: number; fileName: string }) {
    console.log('ProgramService.attachThumbnail... ')
    return Api().post('program/program-attach-thumbnail', { programCommonPropertyId, fileName })
  },
  getProgramPackageForPurchaseCategories () {
    console.log('ProgramService.getProgramPackageForPurchaseCategories... ')
    return Api().get('program/get-program-package-for-purchase-categories')
  },
  programPackageForPurchaseUpsert ({ programPackageForPurchase }: { programPackageForPurchase: ProgramPackageForPurchase}) {
    console.log('ProgramService.programPackageForPurchaseUpsert... ')
    return Api().post('program/program-package-for-purchase-upsert', { programPackageForPurchase })
  },
  deleteProgramPackagesForPurchase ({ programPackagesForPurchaseIds }: { programPackagesForPurchaseIds: number[] }) {
    console.log(' ProgramService.deleteProgramPackagesForPurchase...')
    return Api().delete('program/program-packages-for-purchase-delete', { params: { programPackagesForPurchaseIds } })
  }
  // getOrganizationTransactionRecordsBySuperTutorId (superTutorId, limit, offset) {
  //   console.log('Sending request via GET method to server, waiting for response ...')
  //   return Api().get('finance/org-transaction-records', { params: { super_tutor_id: superTutorId, limit: limit, offset: offset } })
  // },
  // studentClassDisenrollment (studentId, classId) {
  //   console.log('\n studentClassDisenrollment: Sending request via POST method to server, waiting for response ...')
  //   return Api().delete('program/class-enrollment', { params: { student_id: studentId, class_id: classId } })
  // },
  // studentClassEnroll (studentIds, classId) {
  //   console.log('#\nstudentClassEnroll: sending request via POST method to server, waiting for response ...')
  //   return Api().post('program/class-enrollment', { studentIds: studentIds, classId: classId })
  // },
  // getClassStatusItems () {
  //   return Api().get('program/class-status-items')
  // },
  // updateClassStatus (classId, statusCode) {
  //   return Api().put('program/class-update', { id: classId, status_code: statusCode })
  // },
  // getStudentLessonRecords (studentId, programId, limit, offset) {
  //   console.log('Sending request via GET method to server, waiting for response ...')
  //   return Api().get('finance/student-lesson-records', { params: { student_id: studentId, program_id: programId, limit: limit, offset: offset } })
  // },
  // upsertClass (classInfo) {
  //   console.log('ProgramService.upsertClass starts ... ')
  //   return Api().put('program/class-upsert', classInfo)
  // },
  // deleteClass (classId) {
  //   return Api().delete('program/class-delete', { params: { classId: classId } })
  // },
  // getTutors ({ tutorId, mobile, organizationId }) {
  //   console.log('Sending request via GET method to server, waiting for server response ...')
  //   return Api().get('program/tutors', { params: { tutor_id: tutorId, mobile, organization_id: organizationId } })
  // }

  // old functions
  // getVenue ({ classId }) {
  //   console.log('Sending request via GET method to server, waiting for response ...')
  //   return Api().get('getVenueByClassId', { params: { classId: classId } })
  // },
  // createProgram (Info) {
  //   return Api().post('createProgram', Info)
  // },
  // venueAssignmentRemoval (classId, venueId) {
  //   return Api().post('venueAssignmentRemoval', { classId: classId, venueId: venueId })
  // },
  // getLessonPackageCategories () {
  //   return Api().get('getLessonPackageCategories')
  // },
  // getLessonSessionVenueStatusItems () {
  //   return Api().get('getLessonSessionVenueStatusItems')
  // },
  // getLessonSessionTutorStatusItems () {
  //   return Api().get('getLessonSessionTutorStatusItems')
  // },
  // getProgramPackageInfoByProgramId (programId) {
  //   return Api().get('getProgramPackageInfoByProgramId', { params: { programId: programId } })
  // },
  // updateProgram (programInfo, programId = null) {
  //   return Api().post('createProgram', { programInfo: programInfo, programId: programId })
  // },
  // getStudentsByClassId (classId) {
  //   return Api().get('getStudentsByClassId', { params: { classId: classId } })
  // },
  // getStudentById (studentId, programId = null) {
  //   return Api().get('getStudentById', { params: { studentId: studentId, programId: programId } })
  // },
  // getStudentsByOrganizationId (organizationId) {
  //   console.log('Sending request via GET method to server, waiting for server response ...')
  //   return Api().get('getStudentsByOrganizationId', { params: { organizationId: organizationId } })
  // },
  // programPackagePurchase (packageInfo, studentId) {
  //   console.log('Sending request via POST method to server, waiting for response ...')
  //   return Api().post('programPackagePurchase', { packageInfo: packageInfo, studentId: studentId })
  // },
  // getUnenrolledStudentsByProgramId (programId) {
  //   console.log('Sending request via GET method to server, waiting for response ...')
  //   return Api().get('getUnenrolledStudentsByProgramId', { params: { programId: programId } })
  // },
}
